import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ResetPasswordPage() {
  const { search } = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(search)
    const code   = params.get('code')
    if (!code) return

    // 1) Try custom scheme (this should open your app)
    window.location.href = `podrecsmobile://reset-password?code=${code}`

    // 2) Fallback back to HTTPS after 500ms
    const timeout = setTimeout(() => {
      // stays on the same page, where you can render a web reset form
      window.location.href = `/reset-password?code=${code}`
    }, 500)

    return () => clearTimeout(timeout)
  }, [search])

  // Simple UI in case auto‐redirect doesn’t work
  const code = new URLSearchParams(search).get('code')
  return (
    <div style={{
      maxWidth: 360,
      margin: '100px auto',
      textAlign: 'center',
      fontFamily: 'Helvetica, Arial, sans-serif',
      padding: '0 20px'
    }}>
      <h1 style={{ fontSize: 28, marginBottom: 20 }}>Opening Pod Recs…</h1>
      <p style={{ fontSize: 16, marginBottom: 30 }}>
        If it doesn’t open your app automatically, tap below:
      </p>
      <a
        href={`podrecsmobile://reset-password?code=${code}`}
        style={{
          display: 'inline-block',
          backgroundColor: '#dfe339',
          color: '#000',
          padding: '14px 28px',
          borderRadius: 8,
          textDecoration: 'none',
          fontWeight: 'bold',
          fontSize: 16,
          letterSpacing: 1
        }}
      >
        Open in App
      </a>
      {/* <p style={{ fontSize: 14, color: '#555', marginTop: 30 }}>
        Or reset on the website:
      </p>
      <a
        href={`/reset-password?code=${code}`}
        style={{ fontSize: 14, color: '#007aff' }}
      >
        Reset on Web
      </a> */}
    </div>
  )
}
